export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const AES_KEY = process.env.REACT_APP_AES_KEY;
export const AES_IV = process.env.REACT_APP_AES_IV;
export const TOKEN = process.env.REACT_APP_TOKEN;

export function validateEnv() {
  if (!API_ENDPOINT || !AES_KEY || !AES_IV || !TOKEN) {
    throw new Error("Missing environment configuration");
  }
}
